
export const locationTypeOptions = [
  { value: 'En sitio', text: 'En sitio' },
  { value: 'Remoto',   text: 'Remoto' },
]

export const equipmentTypeOptions = [
  { value: 'Abatible o Plegable', text: 'Abatible o Plegable' },
  { value: 'Corredizo', text: 'Corredizo' },
  { value: 'Puerta Automática', text: 'Puerta Automática' },
  { value: 'Seccional', text: 'Seccional' },
  { value: 'Cortina', text: 'Cortina' },
  { value: 'Barrera', text: 'Barrera' },
  { value: 'Control de Acceso', text: 'Control de Acceso' },
  { value: 'Cajeros', text: 'Cajeros' },
  { value: 'Cámaras', text: 'Cámaras' },
  { value: 'Seccional o Elevadizo', text: 'Seccional o Elevadizo' },
  { value: 'Terminal de entrada/salida', text: 'Terminal de entrada o salida' },
  { value: 'Computadora, servidor o caja manual', text: 'Computadora, servidor o caja manual' },
]

export const allowedFileTypes = [
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
  '.xlsx',
  '.csv',
  '.dwg',
  '.docx',
  '.pptx',
  '.dwf'
]

export const sapSeriesOptions = [
  { value: 285,   text: 'OS INST' },
  { value: 248,   text: 'OS OAS' },
  { value: 222,   text: 'OS LABS' },
  { value: 235,   text: 'OS CM' },
  { value: 61,   text: 'OS SERVICIO' },
  { value: 206,   text: 'OS EMERGENCIA' },
  { value: 261,   text: 'OS ATK' }
]

export const sapSeriesMap = {
  285: 'OS INST',
  248: 'OAS',
  222: 'OS LABS',
  235: 'OS CM',
  61: 'OS SERVICIO',
  206: 'OS EMERGENCIA',
  261: 'OS ATK'
}

export const getSapSeriesText = (value) => {
  return sapSeriesOptions.find(option => option.value === value)?.text || '-'
}

export const paymentTypeOptions = [
  { value: 'Sinpe',  text: 'Sinpe' },
  { value: 'Tarjeta',  text: 'Tarjeta' },
  { value: 'Efectivo',  text: 'Efectivo' },
  { value: 'Transferencia',  text: 'Transferencia' },
  { value: 'Credito',  text: 'Crédito' },
]

export const businessUnits = [
  // { value: 0, text: 'Unidad pendiente' },
  { value: 1, text: 'Control de Acceso' },
  { value: 2, text: 'Centro de Servicio COAA' },
  { value: 3, text: 'División Industrial' },
  { value: 4, text: 'Horizontales' },
  { value: 5, text: 'Puertas Automáticas' },
  { value: 6, text: 'Parking' },
  { value: 7, text: 'Servicio Técnico' },
  { value: 8, text: 'Tienda Guanacaste' },
  { value: 9, text: 'Post Venta' },
  { value: 10, text: 'Fabricaciones' },
  { value: 11, text: 'Tienda Heredia' },
  { value: 12, text: 'Tienda Zapote' },
  { value: 13, text: 'Tienda Alajuela' },
  { value: 14, text: 'Contratos de Mantenimiento' },
  { value: 15, text: 'Bodega' },
  { value: 16, text: 'Ingeniería' },
  { value: 17, text: 'Video Vigilancia' },
  { value: 18, text: 'Tienda Calle Blancos' },
  { value: 19, text: 'Supervisor' },
  { value: 20, text: 'Tienda Cartago' },
  { value: 21, text: 'Trea' },
  { value: 22, text: 'Centro de Servicio ATK' }
]

export const getBusinessUnitText = (value) => {
  return businessUnits.find(option => option.value === value)?.text || '-'
}

export const callTypeMap ={
  'unidad_pendiente': 'Unidad Pendiente',
  'control_acceso': 'Control de Acceso',
  'centro_servicio_coaa': 'Centro de Servicio COAA',
  'division_industrial': 'División Industrial',
  'horizontales': 'Horizontales',
  'ptas_automáticas': 'Puertas Automáticas',
  'parking': 'Parking',
  'servicio_técnico': 'Servicio Técnico',
  'tienda_guanacaste': 'Tienda Guanacaste',
  'post_venta': 'Post Venta',
  'fabricaciones': 'Fabricaciones',
  'tienda_heredia': 'Tienda Heredia',
  'tienda_zapote': 'Tienda Zapote',
  'tienda_alajuela': 'Tienda Alajuela',
  'contrato_de_mantenimiento': 'Contrato de Mantenimiento',
  'bodega': 'Bodega',
  'ingeneria': 'Ingeniería',
  'vigilancia': 'Vigilancia',
  'tienda_calle_blancos': 'Tienda Calle Blancos',
  'supervisor': 'Supervisor',
  'tienda_cartago': 'Tienda Cartago',
  'trea': 'Trea',
  'centro_servicio_atk': 'Centro de Servicio ATK'
}

export const callTypeMapByCode = {
  'unidad_pendiente': '-',
  'control_acceso': 'CA',
  'centro_servicio_coaa': 'CSC',
  'division_industrial': 'DI',
  'horizontales': 'HZ',
  'ptas_automáticas': 'PA',
  'parking': 'PK',
  'servicio_técnico': 'ST',
  'tienda_guanacaste': 'TG',
  'post_venta': 'PVT',
  'fabricaciones': 'FB',
  'tienda_heredia': 'TH',
  'tienda_zapote': 'TZ',
  'tienda_alajuela': 'TA',
  'contrato_de_mantenimiento': 'CM',
  'bodega': 'BODEGA',
  'ingeneria': 'ING',
  'vigilancia': 'VV',
  'tienda_calle_blancos': 'TC',
  'supervisor': 'SUP',
  'tienda_cartago': 'TCA',
  'trea': 'TREA',
  'centro_servicio_atk': 'CS-ATK'
}

export const defaultBusinessUnitMap = {
  // 285: { value: 0, text: 'Unidad pendiente' },
  // 248: { value: 0, text: 'Unidad pendiente' },
  222: { value: 2, text: 'Centro de Servicio COAA' },
  235: { value: 14, text: 'Contratos de Mantenimiento' },
  // 61: { value: 0, text: 'Unidad pendiente' },
  206: { value: 7, text: 'Servicio Técnico' },
  261: { value: 22, text: 'Centro de Servicio ATK' }
}

export const setDefaultBusinessUnit = (sapSerie) => {
  const defaultBusinessUnit = defaultBusinessUnitMap[sapSerie] || {}
  if (defaultBusinessUnit.text) {
    return defaultBusinessUnit.value
  }

  return 0
}